export interface ChatMessage {
  from: 'client' | 'master'
  text?: string
  image?: string
  imageAlt?: string
  time: string
}

export interface ChatThread {
  contact: string
  avatar: string
  date: string
  statusTime: string
  battery: string
  messages: ChatMessage[]
}

export const chatThreads: ChatThread[] = [
  {
    contact: 'frances hernandez',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/5104e945-bf0e-4504-a4c5-e0adb9c98667.jpg',
    date: '12 January 2023',
    statusTime: '10:04 am',
    battery: '50%',
    messages: [
      { from: 'master', text: 'buen dia hija frances', time: '06:42 am' },
      {
        from: 'client',
        text: 'Hola maestro, ya obtuve los materiales que requerimos',
        time: '06:42 am',
      },
      {
        from: 'client',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/be867246-fc75-413d-a08d-bdbf02d641ce.jpg',
        imageAlt:
          'Materiales para el ritual sobre la mesa: azúcar, una vela blanca y rosas blancas',
        time: '06:43 am',
      },
      {
        from: 'master',
        text: 'perfecto, con esto iniciaremos el ritual y en las proximas horas obtendras los resultados',
        time: '06:45 am',
      },
    ],
  },
  {
    contact: 'maria lopez',
    avatar:
      'https://cdn.magicpatterns.com/patterns/generated-images/ed18c079-843b-4fc4-a6cf-e700157e9577.jpg',
    date: '3 March 2023',
    statusTime: '09:18 am',
    battery: '47%',
    messages: [
      {
        from: 'client',
        text: 'Hola maestro, ya prendi la vela como me indico',
        time: '09:05 am',
      },
      {
        from: 'client',
        image:
          'https://cdn.magicpatterns.com/patterns/generated-images/be443ef9-01dc-4d82-8d9a-99620eaf98e7.jpg',
        imageAlt:
          'Vela blanca encendida junto a una rosa roja y un vaso con agua sobre la mesa',
        time: '09:06 am',
      },
      {
        from: 'master',
        text: 'perfecto hija, continue asi esta noche y mañana me avisa como se siente',
        time: '09:12 am',
      },
      {
        from: 'client',
        text: 'muchas gracias maestro, ya siento un cambio, bendiciones',
        time: '09:15 am',
      },
    ],
  },
]
